module.exports = __webpack_public_path__ + "img/14.7f15e24b.png";